import { useQuery } from "@tanstack/react-query";
import * as serviceApi from "../../../api/service";

export function useServiceNames() {
  return useQuery({
    queryKey: ["serviceNames"],
    queryFn: () => serviceApi.fetchNames(),
  });
}
